import React from 'react';
import styled from 'styled-components'
import ServiceOption from '../../model/ServiceOption';


const Style = styled.div`

li {
    margin: 0.6rem 0;
}

`;

interface IProps {
    index?:number
    item: ServiceOption
    isAnnual: boolean
    disabled : boolean
}

const ServiceOptionItem:React.FC<IProps> = (props:IProps) => {
    const amount = props.isAnnual ? props.item.priceAnnual : props.item.price;
    const price = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0 }).format(amount);
    return <Style className='service-option'>

            <div>
                <h2 className='light'>{props.index != null && <span>OPTION {props.index} - </span>}
                   {price}  + GST {props.isAnnual ? 'per year' : 'per month'}
                    </h2>

                <ul>
                    { props.item.lineItems.map((x,i)=> <li key={i}>{x}</li>)}                    
                </ul>
            </div>

    </Style>
}

export default ServiceOptionItem;